import * as Sentry from '@sentry/react'

export const log = (message: string, context?: Record<string, any>): void => {
  if (context !== undefined && context !== null) {
    Sentry.captureMessage(message, {
      level: 'info',
      extra: context
    })
  } else {
    Sentry.captureMessage(message)
  }
}

export const error = (err: object | string, context?: Record<string, any>): void => {
  const exception = typeof (err) === 'string' ? new Error(err) : err
  
  if (context !== undefined && context !== null) {
    Sentry.captureException(exception, {
      extra: context
    })
  } else {
    Sentry.captureException(exception)
  }
}

export const addBreadcrumb = (message: string, data?: Record<string, any>): void => {
  Sentry.addBreadcrumb({
    message,
    level: 'info',
    data
  })
}

export const setTag = (key: string, value: string): void => {
  Sentry.setTag(key, value)
}

export const setContext = (name: string, context: Record<string, any>): void => {
  Sentry.setContext(name, context)
}
